import utils from './utils.js'
import Request from './request.js'
export default class {
  async fetchListStation() {
    // if (!this.$store.state.app.stationsAll.length) {
    //   if (this.type === 'company') {
    //     let data = await Request.fetchTollStationTreeNode.call(this, this.isAll)
    //     this.options = this.$store.state.app.company = data.company
    //   } else {
    //     let data = await Request.fetchTollStationTreeNode.call(this, this.isAll)
    //     this.options = this.$store.state.app.stationsAll = data.stations
    //   }
    // } else {
    //   if (this.type === 'company') {
    //     this.options = this.$store.state.app.company
    //   } else {
    //     this.options = this.$store.state.app.stationsAll
    //   }
    // }
    let nodes = {}
    if (this.datatype == 'roadAndGantry') {
      nodes = window.utils.baseInfo.list
    } else if (this.datatype == 'organization') {
      nodes = this.$store.state.app.nodes
    }
    if (this.type === 'company') {
      let company = []
      utils.filterCompany(nodes, company)
      this.options = company
    } else if (this.type === 'users') {
      let users = []
      utils.filterUsers(nodes, users)
      this.options = users
    } else {
      this.options = nodes
    }
    // console.log(this.options)
  }
}
